import React, { Component } from 'react'
import styled from 'styled-components'

const Box = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`

export default class Grid extends Component {
  render() {
    return <Box {...this.props} />
  }
}



// WEBPACK FOOTER //
// ./src/components/Grid/Grid.js